import { AccountManager, btag, pushToDataLayer } from '@atlas/core';
import { onSignUpStepSubmit, onSignUpSubmit, useActiveForm } from '@atlas/react-forms';

import { POSTHOG_CTA, POSTHOG_EVENTS } from 'common/constants';
import { usePostHog } from 'hooks/usePostHog';

const sanitizeRegistrationPayload = formData => {
  for (const field in formData) {
    if (formData[field] === null) {
      // eslint-disable-next-line no-param-reassign
      delete formData[field];
    }
  }
};

const useRegistrationForm = ({ getActiveFormsWithOAuth, onSubmitStart } = {}) => {
  const postHog = usePostHog();

  return useActiveForm(
    'CLIENT_REGISTRATION',
    onSignUpSubmit(formData => {
      onSubmitStart?.();
      pushToDataLayer('registration_form_button_click', btag);
      sanitizeRegistrationPayload(formData);
      // email hashing will be implement in FT-7781
      return AccountManager.formRegistration(formData).then(result => {
        postHog.send(POSTHOG_EVENTS.REGISTRATION, {
          client_id: result.clientId,
          cta_clicked: POSTHOG_CTA.NEXT_STEP,
          email: formData.EMAIL ?? null,
        });
        return result;
      });
    }),
    getActiveFormsWithOAuth,
    onSignUpStepSubmit(formData => {
      return AccountManager.formRegistrationSubmitStep(formData);
    }),
  );
};

export default useRegistrationForm;
